import { useRef, useState } from 'react';
import { Prompt } from 'react-router-dom';
import { Fragment } from 'react/cjs/react.production.min';

import Card from '../UI/Card';
import LoadingSpinner from '../UI/LoadingSpinner';
import classes from './QuoteForm.module.css';

const QuoteForm = (props) => {
  const authorInputRef = useRef();
  const textInputRef = useRef();
  const [isEntering , setIsEntering] = useState(false);

  function submitFormHandler(event) {
    event.preventDefault();

    const enteredAuthor = authorInputRef.current.value;
    const enteredText = textInputRef.current.value;
    
    if(enteredAuthor.length.trim===0 || enteredText.length.trim===0){
      return;
    }

    // optional: Could validate here

    props.onAddQuote({ author: enteredAuthor, text: enteredText });
  }

  const formFocusHandler = ()=> {
    setIsEntering(true);
    console.log('hi');
    return;
  }

  const finishEnteringHandler = () =>{
    if(authorInputRef.current.value.length.trim===0 || textInputRef.current.value.length.trim===0){
      return;
    }

      setIsEntering(false);
  }

  return (
    <Fragment>
      <Prompt when={isEntering} message={(location)=>'Are you sure you want to leave? All your data will lost!'}/>
      <Card>
        <form onFocus={formFocusHandler} className={classes.form} onSubmit={submitFormHandler}>
          {props.isLoading && (
            <div className={classes.loading}>
              <LoadingSpinner />
            </div>
          )}

          <div className={classes.control}>
            <label htmlFor='author'>Author</label>
            <input type='text' id='author' ref={authorInputRef} />
          </div>
          <div className={classes.control}>
            <label htmlFor='text'>Text</label>
            <textarea id='text' rows='5' ref={textInputRef}></textarea>
          </div>
          <div className={classes.actions}>
            <button onClick={finishEnteringHandler} className='btn'>Add Quote</button>
          </div>
        </form>
      </Card>
    </Fragment>
  );
};

export default QuoteForm;
